/**
 * 根据当前租户 ID 生成退出登录后的完整登录地址。
 * 有效纯数字 ID 会写入 redirect，例如 `/login?redirect=/login/886467`；无效 ID 则回退普通登录页。
 *
 * @param tenantId 退出前保存的当前租户 ID
 * @returns 包含项目上下文路径的登录地址
 * @remarks 本方法只拼接字符串且无副作用，调用方负责通过 location.href 执行整页跳转
 */
export const getTenantLoginUrl = (tenantId: string | number | null | undefined): string => {
  const normalizedTenantId = tenantId == null ? '' : String(tenantId);
  const contextPath = import.meta.env.VITE_APP_CONTEXT_PATH || '/';
  const normalizedContextPath = contextPath.endsWith('/') ? contextPath : `${contextPath}/`;
  if (!/^\d+$/.test(normalizedTenantId)) return `${normalizedContextPath}login`;
  return `${normalizedContextPath}login?redirect=/login/${normalizedTenantId}`;
};
